<template>
  <div class="atenciones-page">
    <h1>Reporte de Atenciones</h1>

    <div class="filters">
      <div class="filter-group">
        <label for="manicuristaFilter">Manicurista:</label>
        <select id="manicuristaFilter" v-model="selectedManicuristaId" @change="fetchAttentions">
          <option value="">Todas</option>
          <option v-for="manicurista in manicuristas" :key="manicurista.id" :value="manicurista.id">
            {{ manicurista.nombre }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="startDate">Fecha Inicio:</label>
        <input type="date" id="startDate" v-model="startDate" @change="fetchAttentions">
      </div>

      <div class="filter-group">
        <label for="endDate">Fecha Fin:</label>
        <input type="date" id="endDate" v-model="endDate" @change="fetchAttentions">
      </div>
    </div>

    <div class="summary">
      <h3>Monto Total de Atenciones: ${{ totalAmount.toFixed(2) }}</h3>
    </div>

    <table class="attentions-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Manicurista</th>
          <th>Cliente</th>
          <th>Productos</th>
          <th>Monto</th>
          <th>Observaciones</th>
          <th>Foto</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="attention in attentions" :key="attention.id">
          <td>{{ new Date(attention.fecha).toLocaleDateString() }}</td>
          <td>{{ attention.manicurista_nombre }}</td>
          <td>{{ attention.cliente_nombre }}</td>
          <td>
            <span v-if="attention.productos && attention.productos.length > 0">
              {{ attention.productos.map(p => p.nombre).join(', ') }}
            </span>
            <span v-else>N/A</span>
          </td>
          <td>${{ attention.monto.toFixed(2) }}</td>
          <td>{{ attention.observaciones }}</td>
          <td>
            <img v-if="attention.foto_path" :src="attention.foto_path" alt="Foto Atención" class="attention-photo">
          </td>
        </tr>
        <tr v-if="attentions.length === 0">
          <td colspan="7">No hay atenciones para los filtros seleccionados.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AtencionesPage',
  data() {
    return {
      manicuristas: [],
      selectedManicuristaId: '',
      startDate: new Date().toISOString().slice(0, 10),
      endDate: new Date().toISOString().slice(0, 10),
      attentions: [],
      totalAmount: 0,
    };
  },
  created() {
    this.fetchManicuristas();
    this.fetchAttentions();
  },
  methods: {
    async fetchManicuristas() {
      try {
        const response = await axios.get('/api/manicuristas');
        this.manicuristas = response.data;
      } catch (error) {
        console.error('Error fetching manicuristas:', error);
      }
    },
    async fetchAttentions() {
      try {
        const params = {
          startDate: this.startDate,
          endDate: this.endDate,
          manicuristaId: this.selectedManicuristaId,
        };
        const response = await axios.get('/api/atenciones-filtered', { params });
        this.attentions = response.data;
        this.calculateTotalAmount();
      } catch (error) {
        console.error('Error fetching attentions:', error);
      }
    },
    calculateTotalAmount() {
      this.totalAmount = this.attentions.reduce((sum, attention) => sum + Number(attention.monto), 0);
    },
  },
};
</script>

<style scoped>
.atenciones-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #fff;
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-group label {
  font-weight: bold;
  margin-bottom: 5px;
  color: #555;
}

.filter-group select,
.filter-group input[type="date"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1em;
}

.summary {
  background-color: #e9f7ef;
  border: 1px solid #d0e9d0;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.summary h3 {
  color: #28a745;
  margin: 0;
}

.attentions-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden; /* Ensures rounded corners apply to table content */
}

.attentions-table th,
.attentions-table td {
  border: 1px solid #eee;
  padding: 12px 15px;
  text-align: left;
}

.attentions-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
}

.attentions-table tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}

.attentions-table tbody tr:hover {
  background-color: #f0f0f0;
}

.attention-photo {
  max-width: 80px;
  height: auto;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}
</style>